export const offlineCourses = [
  {
    id: "hands-on",
    number: "01",
    title: "Mastering Smile Transformations",
    subtitle: "Premium Hands-on Course: From knowing veneers to mastering smile transformations",
    mode: "Offline · Across India",
    duration: "2 Days Intensive",
    description:
      "Smile makeovers are more than veneers. They're about understanding facial harmony, aesthetics, function and meticulous execution. Master the art and science of smile transformations through an intensive hands-on program built for dentists who want to confidently plan, prepare and execute high-value smile makeover cases using minimally invasive principles and modern adhesive dentistry.",
    image: "/images/course-smile-makeover.webp",
    fit: "contain",
    tags: ["Live Demonstrations", "Small Batches", "Certificate"],
    curriculum: [
      {
        day: "Day 1",
        blocks: [
          {
            heading: "Lecture · 10:00 AM to 1:30 PM",
            items: [
              "Fundamentals and principles of smile designing and treatment planning",
              "Amalgamation of art and science: the art of mock-up",
              "Carrying out a successful smile trial",
              "Instrumentation",
              "From visualisation to actualisation",
              "Clinical photography",
              "Colour and perception",
              "Minimally invasive preparations",
            ],
          },
          {
            heading: "Live Demonstration · 1:30 PM to 2:30 PM",
            text: "Live demonstration of veneer preparation on a model",
          },
          {
            heading: "Hands-On · 3:00 PM to 5:00 PM",
            items: [
              "Making a putty index",
              "Porcelain veneer preparation: window preparation and incisal overlap",
            ],
          },
        ],
      },
      {
        day: "Day 2",
        blocks: [
          {
            heading: "Lecture · 10:30 AM to 3:00 PM",
            items: [
              "Gingival displacement",
              "Impression and provisionalisation",
              "Try-in and aesthetic evaluation of veneers",
              "Sequence of luting and bonding protocol",
              "Do's and don'ts",
              "Case discussions (diastema closure, peg lateral correction, management of tilted and discoloured teeth)",
              "Workflow of 50 smile makeovers",
            ],
          },
          {
            heading: "Hands-On · 3:00 PM to 5:00 PM",
            text: "Temporisation on model",
          },
        ],
      },
    ],
    outro:
      "From case selection and smile design to preparations, temporization, bonding protocols and finishing, you'll learn every clinical decision that creates beautiful, long-lasting results. Whether you're beginning your aesthetic dentistry journey or looking to refine your existing skills, this program gives you practical techniques and the confidence to take on premium aesthetic cases.",
  },
  {
    id: "internship",
    number: "02",
    title: "3-Month Clinical Internship Program",
    subtitle: "Real-world dentistry, first-hand",
    mode: "Offline · Across India",
    duration: "3 Months Immersive",
    description:
      "A fully immersive 3-month clinical internship designed for dental students and aspiring dentists who want to move beyond textbook learning and experience real-world dentistry first-hand. Interns work alongside Dr. Kshama in a clinical environment, observing, assisting and participating in live patient procedures across aesthetic and general dentistry. This program is designed to build stronger clinical judgement, practical skills and confidence through continuous mentorship and real patient exposure.",
    image:
      "https://static.prod-images.emergentagent.com/jobs/d573e7c6-2766-4699-81b2-a0934f65c126/images/4a5dfc3dcd16e537a606b284824ea22af3ea757e44e294a74ba77b9efed177f7.jpeg",
    tags: ["Live Patient Exposure", "Continuous Mentorship", "Clinical Confidence"],
    curriculum: [
      {
        day: "Curriculum & Clinical Exposure",
        blocks: [
          {
            heading: "What Interns Will Experience",
            items: [
              "Live Patient Procedures: Observe, assist and gain hands-on exposure to real clinical cases",
              "Diagnosis & Treatment Planning: Learn a systematic approach to evaluating and planning cases",
              "Smile Makeover Photography & Documentation: Pre-operative, intra-operative and post-operative protocols",
              "Digital Smile Planning: Digital mock-ups, smile trials and treatment visualisation",
              "Minimally Invasive Veneer Preparations: Clinical principles and preparation protocols",
              "Intraoral Digital Scanning: Learn and master digital impressions and scanning workflows",
              "Temporisation: Step-by-step protocols for provisional restorations",
              "Restoration Trials & Adjustments: Evaluation of fit, aesthetics, contacts and occlusion",
              "Cementation & Luting Protocols: Clinical workflow for final porcelain veneer delivery",
              "1 Complete Smile Makeover: Exposure to a smile transformation case from planning to final delivery",
              "3 Teeth Whitening Procedures: Clinical exposure to professional in-office whitening",
              "General Dentistry: Scaling, fillings, crown preparations, crowns and bridges",
              "Dental Tours: Opportunity to assist Dr. Kshama during dental tours and gain exposure to consultations and treatments beyond the clinic",
              "One-on-One Case Discussions: Detailed mentoring and discussion of cases at every stage",
              "Clinical Photography & Case Documentation: Learn how to professionally document completed treatments",
            ],
          },
        ],
      },
    ],
  },
  {
    id: "whitening-offline",
    number: "03",
    title: "Professional Teeth Whitening Certification",
    subtitle: "Master the Science Behind Predictable Whitening Results",
    mode: "Offline · Across India",
    duration: "1 Day Masterclass",
    description:
      "Professional teeth whitening is one of the most requested aesthetic dental procedures, but achieving safe, consistent and long-lasting results requires far more than simply applying a whitening gel. This intensive hands-on certification course takes you from patient selection and diagnosis to treatment planning, clinical protocols and post-operative care. Its biggest advantage: every participant performs a complete in-office teeth whitening procedure on a live patient under the guidance of Dr. Kshama Chandan, bridging the gap between theory and practice.",
    image:
      "https://static.prod-images.emergentagent.com/jobs/d573e7c6-2766-4699-81b2-a0934f65c126/images/9c0a396daf86e2a512f1821c5d2a34f04ff3613e8e802168eac4f3a13447b938.jpeg",
    tags: ["Live Patient Hands-On", "In-Office Protocols", "Certification"],
    curriculum: [
      {
        day: "What You'll Learn",
        blocks: [
          {
            heading: "Clinical Modules",
            items: [
              "The science behind professional teeth whitening",
              "Intrinsic vs. extrinsic tooth discoloration",
              "Case selection and patient assessment",
              "Step-by-step in-office whitening protocol",
              "Isolation techniques and clinical workflow",
              "Managing sensitivity and contraindications",
              "Evidence-based whitening materials and techniques",
              "Patient communication and expectation management",
              "Post-treatment care and maintenance",
            ],
          },
          {
            heading: "Who Is This Course For?",
            text: "General dentists, fresh graduates, postgraduate students and clinicians looking to confidently introduce professional teeth whitening into their practice through evidence-based protocols and real patient experience.",
          },
          {
            heading: "Course Outcome",
            text: "By the end of this program, you'll be able to accurately diagnose whitening cases, confidently perform professional in-office teeth whitening on your patients, and implement clinically proven protocols that deliver safe, predictable and long-lasting aesthetic results.",
          },
        ],
      },
    ],
  },
];

export const onlineCourses = [
  {
    id: "whitening-online",
    number: "04",
    title: "Teeth Whitening Online",
    subtitle: "Simple, comprehensive online whitening training",
    mode: "Online · Learn From Anywhere",
    duration: "Online Course",
    description:
      "Teeth whitening is one of the most requested, most commonly done and most rewarding dental procedures. Demand has kept pace with advances in vital teeth whitening techniques and patients' constant focus on 'White Smiles'. This simple, comprehensive online course gives easy and very specific practical instructions, helping you develop your skill set and perfect your teeth whitening experience.",
    image: "/images/banner-whitening.webp",
    fit: "banner",
    tags: ["Protocols", "Step-by-Step Training", "Certificate"],
    curriculum: [
      {
        day: "What Will You Learn?",
        blocks: [
          {
            heading: "Course Modules",
            items: [
              "Important need-to-know info",
              "Types and causes of tooth staining",
              "How does teeth whitening work?",
              "Popular, newer and most common whitening systems and materials",
              "How white can you go?",
              "Teeth whitening risks",
              "Teeth whitening after care",
            ],
          },
          {
            heading: "Last But Not The Least",
            text: "Watch a complete step-by-step video of a teeth whitening procedure from start to finish!",
          },
        ],
      },
    ],
  },
  {
    id: "social-media",
    number: "05",
    title: "Social Media for Dentists",
    subtitle: "Build your dental brand online with clarity and confidence",
    mode: "Online · Learn From Anywhere",
    duration: "Live Online Webinar",
    description:
      "Social media is the new word of mouth and for dentists today, building a strong digital presence can directly influence how patients discover, trust and choose you. This webinar is a practical, step-by-step guide to building your dental brand online with clarity and confidence. From creating content and mastering reels to attracting the right audience and converting followers into patients, you'll learn actionable strategies designed specifically for dentists who want to grow their practice in the digital world.",
    image: "/images/banner-social.webp",
    fit: "banner",
    tags: ["Personal Branding", "Reels Strategy", "Patient Growth"],
    curriculum: [
      {
        day: "What You'll Learn",
        blocks: [
          {
            heading: "The New Word of Mouth",
            text: "For decades dentists relied exclusively on word of mouth to help them build their practice. A quick reality check: it's 2025 and more likely than not, social media is the 'new word of mouth'. The world of digital visibility can be overwhelming and intimidating, but the truth is, once mastered it can be an incredibly powerful platform for you and your practice. I've turned years of learning (and trial and error) into a step-by-step program that shows you not just what to do, but exactly how to do it, from building an online presence to converting followers into patients.",
          },
          {
            heading: "Course Modules",
            items: [
              "Getting started with social media",
              "Overcoming fears & setting goals",
              "What to post, when to post & using hashtags",
              "Attracting your ideal patients",
              "Creating authentic engagement",
              "Staying consistent with filming, photos & tools",
              "Proven strategies to turn followers into patients",
              "Social media management tools and techniques for consistent growth",
            ],
          },
          {
            heading: "Plus: All About Reels",
            items: [
              "Understanding & batching reels",
              "Strategies that get views",
              "Creating relevant, value driven content that actually works",
            ],
          },
        ],
      },
    ],
    outro: "Grow your practice effectively, creatively, confidently and digitally.",
  },
  {
    id: "veneers",
    number: "06",
    title: "The Complete Porcelain Veneer Blueprint",
    subtitle: "Live online webinar, from the comfort of your home",
    mode: "Online · Learn From Anywhere",
    duration: "Live Online Webinar",
    description:
      "Porcelain veneers are no longer just a cosmetic procedure. They've become one of the most sought-after treatments in aesthetic dentistry. Creating smiles that look effortless, natural and long-lasting requires far more than simply preparing teeth and bonding porcelain. It demands a systematic approach. This intensive live online webinar takes you through the exact clinical workflow from treatment planning to final cementation, so you can achieve predictable, aesthetic outcomes with confidence.",
    image: "/images/banner-veneers.webp",
    fit: "banner",
    tags: ["Live Webinar", "Interactive Q&A", "Limited Seats"],
    curriculum: [
      {
        day: "During This Webinar, You'll Learn",
        blocks: [
          {
            heading: "Webinar Modules",
            items: [
              "Case selection and treatment planning",
              "Indications and contra-indications of veneers",
              "Mock-up and smile trial protocols",
              "Instrumentation and armamentarium",
              "Veneer preparation guidelines",
              "Temporisation techniques",
              "Gingival displacement",
              "Impression protocols and digital scanning",
              "Veneer try-in and evaluation",
              "Adhesive bonding and cementation sequence",
              "Clinical tips and tricks, common mistakes, and how to avoid them",
            ],
          },
          {
            heading: "How It Works",
            items: [
              "Attend live, from the comfort of your home or clinic",
              "Learn. Interact. Ask questions live.",
            ],
          },
        ],
      },
    ],
    outro:
      "Whether you're just starting your veneer journey or looking to refine your existing skills, this webinar will give you practical protocols that you can immediately implement in your very next veneer case. If you're serious about delivering natural, predictable smile transformations, this webinar is for you. Limited seats available. Reserve your spot today.",
  },
];
